import { render, staticRenderFns } from "./contractRentDashboard.vue?vue&type=template&id=01a5893a&"
import script from "./contractRentDashboard.vue?vue&type=script&lang=js&"
export * from "./contractRentDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports